import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';

const Preloader = ({ isFallback = false, forceShowOverlay = false }) => {
  const { t } = useLanguage();
  const [isLoading, setIsLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (isFallback) {
      // Khi dùng làm Suspense fallback, bỏ qua logic và window.load
      return;
    }

    const handleLoad = () => {
      setFadeOut(true);
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
    }

    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, [isFallback]);

  // Nếu là fallback chuyển trang bình thường và không ép buộc hiện overlay -> ẩn đi
  if (isFallback && !forceShowOverlay) return null;

  // Nếu là tải trang lần đầu tiên và đã hoàn thành loading -> ẩn đi
  if (!isLoading && !isFallback) return null;

  return (
    <div className={`preloader-overlay ${fadeOut && !isFallback ? 'fade-out' : ''}`}>
      <div className="preloader-content">
        <div className="spinner"></div>
        <p className="loading-text">{t('common.loading')}</p>
        <p className="preloader-subtitle">{t('common.kent_project')}</p>
      </div>
    </div>
  );
};

export default Preloader;
